import * as React from 'react';
import { memo } from 'react';

import { isNumber } from '@impuls-coach/util-is';

export type CounterProps = {
	count?: string | number;
	modifier?: string;
};

const Counter = ({ count, modifier }: CounterProps): any => {
	if (!isNumber(count)) {
		return null;
	}

	return (
		<div className={`a-counter${modifier ? ` a-counter--${modifier}` : ''}`}>
			<span className="a-counter__number">{count}</span>
		</div>
	);
};

export { Counter };
export default memo(Counter, (prevProps, nextProps) => {
	return prevProps.count === nextProps.count;
});
